export class MensagemRetorno {

    static mensagemRetornoStatus(retornoErro: any) {
        switch (String(retornoErro).substring(0,1)) {
            case '5':
                return MensagensEnum.MENSAGEM_ERR_HTTP_500;
            case '4':
                return MensagensEnum.MENSAGEM_ERR_HTTP_400;
            case '2':
                return MensagensEnum.MENSAGEM_VAZIO_HTTP_200;
        }
    }

}


export enum MensagensEnum {
    MENSAGEM_ERR_HTTP_500 = 'Não temos essa informação no momento. Por favor, tente novamente mais tarde',
    MENSAGEM_ERR_HTTP_400 = 'Não temos essa informação no momento. Por favor, tente novamente mais tarde',
    MENSAGEM_VAZIO_HTTP_200 = 'Nenhuma informação encontrada',
}
